import React from "react";
import { useState } from "react";

const Description = ({ selectedTour }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const maxLength = 150;

  // Hàm loại bỏ thẻ HTML và format văn bản
  const stripHtml = (html) => {
    // Loại bỏ tất cả thẻ HTML, thay bằng khoảng trắng
    let plainText = html
      .replace(/<[^>]+>/g, " ") // Thay thẻ HTML bằng khoảng trắng
      .replace(/\s+/g, " ") // Chuẩn hóa khoảng trắng
      .trim(); // Xóa khoảng trắng thừa

    // Các từ khóa để tách đoạn
    const sectionKeywords = [
      "NGÀY \\d+:",
      "Sáng:",
      "Chiều:",
      "Tối:",
      "Trưa:",
      "\\d{1,2}h\\d{2}:", // Định dạng giờ như 7h00, 12h00
    ];
    const sectionRegex = new RegExp(`(${sectionKeywords.join("|")})`, "gi");

    // Tách thành các đoạn dựa trên từ khóa
    let sections = [];
    let currentSection = "";
    const lines = plainText.split(" ").filter(Boolean);

    lines.forEach((word, index) => {
      const currentLine = lines.slice(0, index + 1).join(" ");
      if (sectionRegex.test(word) && currentSection) {
        sections.push(currentSection.trim());
        currentSection = word;
      } else {
        currentSection += (currentSection ? " " : "") + word;
      }
    });

    // Thêm đoạn cuối cùng
    if (currentSection) {
      sections.push(currentSection.trim());
    }

    // Nối các đoạn với \n
    return sections.join("\n");
  };

  if (!selectedTour || !selectedTour.tourDetails) return <p>Loading...</p>;

  const plainDescription = stripHtml(selectedTour.description);
  const isLongText = plainDescription.length > maxLength;
  const shortText = plainDescription.slice(0, maxLength) + "...";

  return (
    <>
      <div className="bg-light-200 card-bg-light mb-4">
        <h5 className="fs-18 mb-3">Mô tả</h5>
        <div className="mb-2">
          <p style={{ whiteSpace: "pre-line" }}>
            {isExpanded || !isLongText ? plainDescription : shortText}
          </p>
        </div>

        {isLongText && (
          <div className="read-more">
            <a
              href="#"
              className="fs-14 fw-medium more-link text-decoration-underline mb-2"
              onClick={(e) => {
                e.preventDefault();
                setIsExpanded(!isExpanded);
              }}
            >
              {isExpanded ? "Thu gọn" : "Xem thêm"}
            </a>
          </div>
        )}
      </div>
      {/* <!-- /Description -->

                    <!-- Highlights --> */}
      <div className="bg-light-200 card-bg-light mb-4">
        <h5 className="fs-18 mb-3">Điểm nổi bật</h5>
        <div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              Trải nghiệm địa phương – Khám phá văn hóa, ẩm thực và phong tục
              địa phương độc đáo.
            </p>
          </div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              Hướng dẫn viên chuyên nghiệp – Hỗ trợ tận tình, cung cấp thông tin
              chi tiết về điểm đến.
            </p>
          </div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              Lịch trình hấp dẫn – Kết hợp giữa tham quan danh lam thắng cảnh,
              hoạt động giải trí và thời gian thư giãn.
            </p>
          </div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              Dịch vụ tiện nghi – Phương tiện di chuyển thoải mái, khách sạn
              chất lượng, bữa ăn ngon.
            </p>
          </div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              An toàn & Bảo hiểm – Cam kết an toàn cho du khách với các biện
              pháp bảo hộ và bảo hiểm du lịch.
            </p>
          </div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              Chi phí hợp lý – Giá cả cạnh tranh với nhiều gói ưu đãi, dịch vụ
              chất lượng.
            </p>
          </div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              Linh hoạt & Cá nhân hóa – Lịch trình có thể điều chỉnh theo nhu
              cầu khách hàng.
            </p>
          </div>
          <div className="d-flex align-items-center mb-2">
            <span className="avatar avatar-md bg-primary-transparent rounded-circle me-2">
              <i className="isax isax-send-sqaure-2 fs-16"></i>
            </span>
            <p>
              Cơ hội giao lưu – Kết nối với bạn bè mới, giao lưu với người bản
              địa và mở rộng hiểu biết.
            </p>
          </div>
        </div>
      </div>
      {/* <!-- /Highlights -->

                    <!-- Itinerary --> */}
      <div className="bg-light-200 card-bg-light mb-4">
        <h5 className="fs-18 mb-3">Lịch trình</h5>
        <div className="card shadow-none mb-0">
          <div className="card-body p-3">
            <div className="stage-flow">
              {selectedTour.tourDetails.map((detail, index) => (
                <div
                  key={detail.detailId}
                  className="d-flex align-items-center flows-step"
                >
                  <span className="flow-step">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div className="flow-content">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div>
                        <h6 className="fw-medium mb-1">
                          Ngày {detail.dayNumber}: {selectedTour.tourName}
                        </h6>
                        <p>
                          Thời gian:{" "}
                          {new Date(
                            selectedTour.createdDate
                          ).toLocaleDateString("vi-VN")}
                        </p>
                      </div>
                    </div>
                    <p style={{ whiteSpace: "pre-line" }}>
                      {stripHtml(detail.description)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Itinerary -->

                    <!-- Includes & Excludes --> */}
      <div className="bg-light-200 card-bg-light mb-4">
        <h5 className="fs-18 mb-3">Bao gồm & Không bao gồm</h5>
        <div className="row gy-2">
          {/* Bao gồm */}
          <div className="col-md-6">
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-tick-square5 text-success me-2"></i>
              Vé tham quan theo lịch trình
            </p>
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-tick-square5 text-success me-2"></i>
              Hướng dẫn viên chuyên nghiệp
            </p>
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-tick-square5 text-success me-2"></i>
              Phương tiện di chuyển suốt chuyến đi
            </p>
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-tick-square5 text-success me-2"></i>
              Bảo hiểm du lịch
            </p>
            <p className="d-flex align-items-center">
              <i className="isax isax-tick-square5 text-success me-2"></i>
              Các bữa ăn theo chương trình
            </p>
          </div>

          {/* Không bao gồm */}
          <div className="col-md-6">
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-close-square5 text-danger me-2"></i>
              Vé máy bay & phí hành lý ký gửi
            </p>
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-close-square5 text-danger me-2"></i>
              Chi phí cá nhân (mua sắm, điện thoại, giặt ủi)
            </p>
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-close-square5 text-danger me-2"></i>
              Đồ uống ngoài chương trình
            </p>
            <p className="d-flex align-items-center mb-2">
              <i className="isax isax-close-square5 text-danger me-2"></i>
              Tiền tip cho tài xế & hướng dẫn viên
            </p>
            <p className="d-flex align-items-center">
              <i className="isax isax-close-square5 text-danger me-2"></i>
              Các chi phí phát sinh không có trong lịch trình
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Description;